<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-danger ">
		<div class="card-header">
			Zones
		</div>
		<div class="card-body overflow-auto">
				<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Zone Code</th>
								<th>Zone Name</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in zones" :key="j.id">
								<td>{{j.zone_code}}</td>
								<td>{{j.name}}</td>
								<td>
									<button class="btn btn-danger fa fa-trash" @click="deleteZone(j.id)"></button>
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
				  <div class="col-sm-12">
    				<div class="row">
    					<div :class="['form-group', errors.name ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="form.name" placeholder="Enter new zone name">
    						<span v-if="errors.name" :class="['badge bg-danger']">Please enter a valid zone name.</span>
    					</div>
    					<div :class="['form-group', errors.zone_code ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="form.zone_code" placeholder="Enter new zone code">
    						<span v-if="errors.zone_code" :class="['badge bg-danger']">Please enter a valid zone code.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addZone"><i class="fa fa-plus"></i> Add Zone</button>
    					</div>
    				</div>
    			</div>
		</div>
	</div>
</div>

<div class="col-lg-12">
	<div class="card card-danger ">
		<div class="card-header">
			Zone Branches
		</div>
		<div class="card-body overflow-auto">
				<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Zone</th>
								<th>Branch</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in branchzones" :key="j.id">
								<td>{{j.zone_code}}</td>
								<td>{{j.fullname}}</td>
								<td>
									<button class="btn btn-danger fa fa-trash" @click="deleteBranch(j.id)"></button>
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
				<div class="col-sm-12">
    				<div class="row">
    					<div :class="['form-group', errors.zone ? 'has-error' : '']">
    						<v-select :options="zones" label="name" :reduce="zones => zones.zone_code" v-model="zone" placeholder="Choose zone"></v-select>
    						<span v-if="errors.zone" :class="['badge bg-danger']">Please enter a valid zone name.</span>
    					</div>
    					<div :class="['form-group', errors.zone_code ? 'has-error' : '']">
    						<v-select :options="branches" label="branch" :reduce="branches => branches.branch_code" v-model="branch" placeholder="Choose branch"></v-select>
    						<span v-if="errors.branch" :class="['badge bg-danger']">Please enter a valid branch.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addZoneBranch"><i class="fa fa-plus"></i> Add Zone</button>
    					</div>
    				</div>
    			</div>
		</div>
	</div>
</div>

<div class="col-lg-12">
	<div class="card card-danger ">
		<div class="card-header">
			Zonal Managers
		</div>
		<div class="card-body overflow-auto">
				<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Zone</th>
								<th>Manager</th>
								<th>Role</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in zonalmanagers" :key="j.id">
								<td>{{j.master_zone.name}}</td>
								<td>{{j.user.user_detail}}</td>
								<td>{{j.role}}</td>
								<td>
									<button class="btn btn-danger fa fa-trash"></button>
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
				<div class="col-sm-12">
    				<div class="row">
    					<div :class="['form-group', errors.zone_id ? 'has-error' : '']">
    						<v-select :options="zones" label="name" :reduce="zones => zones.id" v-model="zone_id" placeholder="Choose zone"></v-select>
    						<span v-if="errors.zone_id" :class="['badge bg-danger']">Please select a zone.</span>
    					</div>
    					<div :class="['form-group', errors.manager_id ? 'has-error' : '']">
    						<v-select :options="managers" label="user_detail" :reduce="managers => managers.id" v-model="manager_id" placeholder="Choose manager"></v-select>
    						<span v-if="errors.manager_id" :class="['badge bg-danger']">Please select a manager.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addZoneManager"><i class="fa fa-plus"></i> Add Zone Manager</button>
    					</div>
    				</div>
    			</div>
		</div>
	</div>
</div>

</section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getZones();
        	this.getBranchZones();
        	this.getBranches();
        	this.getManagers();
        	this.getUsers();
        },

        data() {
        	return {
        		form: new Form({
        			name: '',
        			zone_code: ''
        		}),

        		zones: [],
        		errors: [],
        		branchzones: [],
        		zone: '',
                zonename:'',
                zonecode:'',
        		branch: '',
        		branches: [],
        		zone_id: '',
        		manager_id: '',
        		managers: [],
        		zonalmanagers: []
        	}
        },

        methods: {
        	getBranches(){
        		axios.post("/api/getSAPBranches")
        		.then(response => {
        			this.branches = response.data;
        		})
        	},

        	addZoneBranch(){
        		axios.post("/api/addZoneBranch", {zone: this.zone, branch: this.branch})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Added!'
        			});
        			this.getBranchZones();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getBranchZones(){
        		axios.post("/api/getZoneBranches")
        		.then(response => {
        			this.branchzones = response.data;
        		})
        	},

        	deleteBranch(id){
        		axios.post("/api/deleteZoneBranch", {id:id})
        		.then(response => {
        				toast.fire({
		      				icon: "success",
		      				title: "Deleted!"
		      			});
		      			this.getBranchZones();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	addZone(){
        		this.form.post("/api/addZone")
        		.then(response => {
        				toast.fire({
		      				icon: "success",
		      				title: "Zone Added!"
		      			});
		      			this.getZones();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getZones(){
        		axios.post("/api/getZones",{results: this.results, name: this.zonename, zone: this.zonecode})
        		.then(response => {
        			this.zones = response.data;
        		})
        	},

        	deleteZone(id){
        		axios.post("/api/deleteZone", {id:id})
        		.then(response => {
        				toast.fire({
		      				icon: "success",
		      				title: "Zone Deleted!"
		      			});
		      			this.getZones();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	addZoneManager(){
        		var role = this.managers.find(x => x.id === this.manager_id).user_type;
        		axios.post("/api/createZonalManager", {zone_id: this.zone_id, user_id: this.manager_id, role: role})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Zonal Manager Added'
        			});
        			this.getManagers();
        		});
        	},

        	getManagers(){
        		axios.post("/api/getZonalManagers")
        		.then(response => {
        			this.zonalmanagers = response.data;
        		});
        	},

        	getUsers(){
        		var types = ['zonal-manager', 'ast-zonal-manager'];
        		axios.post("/api/getMatchingUsers",{types: types})
        		.then(response => {
        			this.managers = response.data;
        		});
        	}
        }
    }
</script>
